import { useTranslation } from "react-i18next";
import { parseUiPart } from "@graftus/ui-parts";
import type { IntelligenceMemberRoster } from "../intelligenceMarkdownUtils";
import type { DataPartLike } from "../chat-tool-utils";
import { MetricTablePart } from "./MetricTablePart";

/**
 * Renders the typed `data-*` parts of an assistant message. Unknown parts
 * and payloads that fail their schema render nothing (`parseUiPart`), so a
 * newer server never breaks an older client.
 */
export function DataParts({
  parts,
  businessId,
  roster,
}: {
  parts: DataPartLike[];
  businessId?: string;
  roster?: IntelligenceMemberRoster | null;
}) {
  const { i18n } = useTranslation("intelligence");
  const locale = i18n.language.startsWith("en") ? "en-GB" : "sv-SE";
  const rendered = parts
    .map((part) => ({ key: part.id ?? part.type, parsed: parseUiPart(part.type, part.data) }))
    .filter((entry) => entry.parsed !== null);
  if (rendered.length === 0) return null;
  return (
    <div className="flex flex-col gap-2">
      {rendered.map(({ key, parsed }) =>
        parsed!.name === "metric-table" ? (
          <MetricTablePart
            key={key}
            table={parsed!.data}
            businessId={businessId}
            roster={roster}
            locale={locale}
          />
        ) : null,
      )}
    </div>
  );
}
